import pluralize from "pluralize";
import React from "react";

import Package from "../search/package/Package";

import { json } from "../../shared/fetcher";
import { FALLBACK_NUMBER, FALLBACK_NUMBER_HREF } from "../../shared/helpers/ellipsis";

class PackageGenerator extends React.Component {
  constructor() {
    super();

    this.state = {
      package: null,
      venue: null
    };
  }

  componentDidMount() {
    const { packageId, slug } = this.props;

    if (packageId) {
      this.getPackage(packageId, { slug });
    } else if (slug) {
      this.getCheapestPackage({ slug });
    }
  }

  getPackage = (id, params = {}) => {
    const queryParams = Object.keys(params)
      .map(param => `${param}=${params[param]}`)
      .join("&");
    const idSlug = id ? `/${id}` : "";
    const packagesAPI = `/api/packages${idSlug}?${queryParams}`;

    json(packagesAPI)
      .then(data => {
        const pkg = data.package || (data.packages && data.packages[0]);

        if (pkg) {
          this.setState({ package: pkg, venue: data.venue });
        }
      });
  };

  getCheapestPackage = (params = {}) => {
    this.getPackage(null, { ...params, cheapest: true });
  };

  packageTitle = () => {
    const _package = this.state.package;
    const unlimitedRounds = _package.total_nights === -1;
    const nights = pluralize("Night", _package.total_nights, true);
    const rounds = unlimitedRounds ? "Unlimited Rounds" : pluralize("Round", _package.total_rounds, true);

    return [nights, rounds].join(", ");
  };

  render() {
    const { state } = this;
    if (!state.package) {
      return null;
    }
    const { package: pkg, venue } = state;

    return (
      <Package
        key={state.venue.slug}
        id={pkg._id}
        name={this.packageTitle()}
        price={pkg.price}
        nights={pkg.total_nights}
        rounds={pkg.total_rounds}
        roundsDetails={pkg.round_allocations}
        boardBasis={pkg.board_basis}
        promotions={pkg.special_offers}
        transportation={pkg.transportation}
        isFeatured={false}
        venueStarRating={venue.rating}
        venueReviewCount={venue.reviews}
        venueName={venue.name}
        venueLat={parseFloat(venue.lat)}
        venueLon={parseFloat(venue.lon)}
        venueRegionName={venue.place}
        venueImageUrlSmallPalm={venue.images.smallPalm}
        venueImageUrlPalmAndUp={venue.images.palmAndUp}
        venueUrl={venue.slug}
        fallbackNumber={FALLBACK_NUMBER}
        fallbackNumberHref={FALLBACK_NUMBER_HREF}
      />
    );
  }
}

export default PackageGenerator;



// WEBPACK FOOTER //
// ./components/static_pages/PackageGenerator.jsx